import Img from "react-cloudimage-responsive";
import Link from "next/link";
import React from "react";
import CheckinProgress from "./checkin_progress";
import { AppReducerStateProps } from "lib/store";
import { connect } from "react-redux";
import { CheckWithPrefixResponse } from "lib/infomation_vender/document";

interface UgameProps {
  state: AppReducerStateProps;
  information: CheckWithPrefixResponse;
}

function Ugame(_props: UgameProps) {
  const slides = [
    {
      pic: "udiamond-ucheckin-3.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/uGame/check_in",
      disable: false,
      title: "เช็คชื่อ",
    },
    {
      pic: "udiamond-ubox-3.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/uGame/open_ubox",
      disable: false,
      title: "เปิดกล่อง",
    },

    //  {
    //  pic: "uspin-iphone-home-2.png",
    //bg: "shadow border-radius fade-color-blue",
    //location: "/uGame/uspin",
    //disable: props.information.prefix != "snb",
    //},
    //{
    // pic: "ugame-rps.png",
    //bg: "shadow border-radius fade-color-blue",
    //location: "/uGame/urps",
    //disable: false,
    //},

    {
      pic: "ugame_ucomment.png",
      bg: "shadow border-radius fade-color-blue",
      location: "/comment_all",
      disable: false,
      title: "รีวิวแจก uDiamond",
    },
  ];

  return (
    <div style={{ marginTop: 20, marginBottom: -20 }}>
      <h3>
        <span>กิจกรรมภายในเว็บ</span>
      </h3>
      <div className="row wrapper">
        {slides.map((el, i) => {
          if (el.disable) {
            return <></>;
          }

          if (el.location == "/uGame/check_in") {
            return (
              <div
                className="col-6 col-md-3 col-xxl-2 margin-top-10 grid"
                style={{ marginTop: -10 }}
                key={i}
              >
                <Link href={el.location}>
                  <a style={{ textDecoration: "none" }}>
                    <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                      <Img
                        className="shine"
                        ratio={1 / 1}
                        src={el.pic ?? ""}
                        alt={el.pic}
                      ></Img>
                      <div
                        className="row text-center"
                        style={{
                          marginTop: -30,
                          marginLeft: 2,
                          marginRight: 2,
                        }}
                      >
                        <div className="col-12 shadow" style={{ zIndex: 1 }}>
                          <CheckinProgress></CheckinProgress>
                        </div>
                      </div>
                      <div className="text-center" style={{ marginTop: 15 }}>
                        <span>{el.title}</span>
                      </div>
                    </div>
                  </a>
                </Link>
              </div>
            );
          }

          return (
            <div
              className="col-6 col-md-3 col-xxl-2 margin-top-10 grid"
              style={{ marginTop: -10 }}
              key={i}
            >
              <Link href={el.location}>
                <a style={{ textDecoration: "none" }}>
                  <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                    <Img
                      className="shine"
                      ratio={1 / 1}
                      src={el.pic ?? ""}
                      alt={el.pic}
                    ></Img>
                    <div className="text-center">
                      <span>{el.title}</span>
                    </div>
                  </div>
                </a>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(Ugame);
